<!-- eslint-disable -->
<template lang="pug">
    .billing-banner
        .billing-banner__header
            | {{ $i18n.t('dashboard.dashboard_sidebar_billing') }}
        divider(:margin="'0 auto'" :not-show-last-child="true")
        .billing-banner__body(v-if="!isLoading")
            .billing-banner__slot-body
                slot
            .billing-banner__schools(v-if="records.length", v-for="(record, index) in records" :key="record.id")
                .billing-banner__school
                    router-link.school__name(:to="{name: 'school:profile', params: {id: record.id}}" :title="record.name")
                        | {{ record.name }}
                    .school__balance-block(v-if="record.account")
                        | {{ $i18n.t('list.list_billing_balance') }}:&nbsp;
                        span.school__balance
                            | {{ amountString(record.account.balance, true) }}
                    router-link.school__button(
                        :to="{name: 'school:profile', params: {id: record.id}}"
                        :title="$i18n.t('list.list_billing_changeBalance')"
                    )
                        | {{ $i18n.t('list.list_billing_changeBalance') }}
                    divider(:margin="'0 auto'" :not-show-last-child="true")
            .billing-banner__empty(v-else) {{ $i18n.t('errors.getting_schools') }}
        cs-loader(v-else="")
</template>

<script>
    /*eslint-disable*/
    import TransactionsApi from "../../../api/billing/transactions";
    import {mapState} from "vuex";

    export default {
        mounted () {
            this.fetchData();
        },
        data () {
            return {
                isLoading: false,
                records: [],
                form: {
                    month: 'current',
                    dateTo: null,
                    dateFrom: null,
                },
            }
        },
        methods: {
            fetchData () {
                this.isLoading = true;
                this.form.dateFrom = this.$moment().startOf('month').format('YYYY-MM-DD');
                this.form.dateTo = this.$moment().endOf('month').format('YYYY-MM-DD');
                TransactionsApi.list(this.form)
                .then(response => {
                    this.records = response.data;
                    this.isLoading = false;
                })
                .catch(error => {
                    this.isLoading = false;
                    this.$toasted.error('errors.getting_schools');
                });
            },
            amountString (amount, isBalance = false) {
                let number = isBalance ? amount : Math.abs(amount);
                return number + " " + this.$i18n.tc('olympiads.olympiads_olympiadForm_rubles', number);
            },
        },
        computed: {
            ...mapState({
                user: state => state.auth.user,
            })
        },
    }
</script>

<style lang="scss" scoped>
    .billing-banner {
        padding: 30px;
        box-sizing: border-box;
        background-color: $hsl-color-gray-98;
        border-radius: $border-radius-20;

        display: flex;
        flex-direction: column;
        justify-content: space-between;

        &:not(:last-child) {
            margin-bottom: 30px;
        }
    }

    .billing-banner__header {
        font-weight: 500;
        font-size: 22px;
        line-height: 26px;
        margin-bottom: 25px;
    }

    .billing-banner__body {
        font-size: 16px;
        line-height: 24px;
        margin-top: 30px;
    }

    .billing-banner__school {
        margin-top: 30px;
        display: flex;
        justify-content: space-between;
    }

    .school__balance {
        font-weight: 500;
    }

    .school__name, .school__button {
        color: $hsl-color-blue-56;
        text-decoration: underline;
        &:hover {
            color: $hsl-color-blue-56;
            text-decoration: none;
        }
    }

    .billing-banner__slot-body {
        margin: -30px;
    }

    .billing-banner__school {
        flex-direction: column;
        @include media($sm) {
            flex-direction: row;
        }
    }
</style>
